module.exports = __webpack_public_path__ + "img/2.d6f8b45a.webp";